"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Categories = void 0;
var _mui = require("@ori-ui/mui");
const Categories = exports.Categories = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'grid',
  gap: theme.spacing(2),
  gridTemplateColumns: '1fr 1fr 1fr 1fr 1fr',
  overflow: 'hidden',
  [theme.breakpoints.up('sm')]: {
    gap: theme.spacing(8)
  }
}));
